// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"6992":"49edba2a6e8f9935","8162":"5527a67629bcde69"}[chunkId] + ".js";
};